import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const DyslipidemiaPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Dyslipidemia</h1>
        <section className="mb-8">
          <p>Dyslipidemia refers to abnormal levels of lipids (fats) in the blood, such as high cholesterol or triglycerides. It can increase the risk of heart disease and other health issues. Natural therapies can help balance lipid levels and support overall cardiovascular health.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Poor diet</li>
            <li>Lack of physical activity</li>
            <li>Obesity</li>
            <li>Genetic factors</li>
            <li>Underlying health conditions</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Often asymptomatic</li>
            <li>High cholesterol levels</li>
            <li>High triglyceride levels</li>
            <li>Increased risk of heart disease</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use heart-healthy herbs, dietary guidance, and lifestyle coaching to balance lipid levels, reduce cardiovascular risk, and promote overall wellness. Each plan is tailored to your needs for safe, effective care.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Balances lipid levels</li>
            <li>Supports heart health</li>
            <li>No harsh side effects</li>
            <li>Personalized, gentle care</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Eat a heart-healthy diet</li>
            <li>Stay physically active</li>
            <li>Maintain a healthy weight</li>
            <li>Regular check-ups with healthcare providers</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment help with dyslipidemia?</strong>
            <p>A: Yes, our approach can support balanced lipid levels and heart health.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this safe for seniors?</strong>
            <p>A: Absolutely, our therapies are gentle and suitable for all ages.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How soon will I see improvement?</strong>
            <p>A: Many patients notice improvement within a few weeks.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Support your heart—book your natural dyslipidemia consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default DyslipidemiaPage; 